import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import { SystemProvider } from "./context/system_context";

// Provider Imports
import { Provider } from "react-redux";
import { store } from "./store";

// Maintenance imports
import {
  MaintenanceProvider,
  useMaintenance,
} from "./context/MaintenanceContext";
import MaintenancePage from "./pages/MaintenancePage";

// CSS Imports
import "./index.css";

import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const LoadingSpinner = () => {
  return (
    <Box
      className="flex items-center justify-center"
      sx={{
        height: "100vh", // Make it take the full viewport height
        display: "flex", // Ensure flexbox for centering
        alignItems: "center", // Vertical centering
        justifyContent: "center", // Horizontal centering
      }}
    >
      <CircularProgress size={42} thickness={4} className="text-red-100" />
    </Box>
  );
};

const RootComponent = () => {
  const { isUnderMaintenance, isLoading } = useMaintenance();

  if (isLoading) {
    return <LoadingSpinner />; // Loading state while fetching API status
  }

  if (isUnderMaintenance) {
    return <MaintenancePage />;
  }

  return (
    <BrowserRouter basename="/fibre/prepaid">
      <Provider store={store}>
        <SystemProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
        </SystemProvider>
      </Provider>
    </BrowserRouter>
  );
};

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

root.render(
  <MaintenanceProvider>
    <RootComponent />
  </MaintenanceProvider>
);
